module.exports = __webpack_public_path__ + "build/images/ddbc8f249b.png?ddbc8f24";